var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0555 0.867432C24.4774 0.867432 31.3279 7.61282 31.3279 15.9056C31.3279 19.8181 29.803 23.3865 27.3077 26.0646L32.2177 30.8892C32.6773 31.3417 32.6788 32.0737 32.2193 32.5261C31.9903 32.7547 31.6876 32.8674 31.3865 32.8674C31.087 32.8674 30.7859 32.7547 30.5553 32.5292L25.586 27.6498C22.9719 29.7112 19.6574 30.9453 16.0555 30.9453C7.63353 30.9453 0.781494 24.1983 0.781494 15.9056C0.781494 7.61282 7.63353 0.867432 16.0555 0.867432ZM16.0555 3.18384C8.93054 3.18384 3.13399 8.88994 3.13399 15.9056C3.13399 22.9212 8.93054 28.6289 16.0555 28.6289C23.1788 28.6289 28.9754 22.9212 28.9754 15.9056C28.9754 8.88994 23.1788 3.18384 16.0555 3.18384Z",
    fill: "#F5FBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1a10d750.svg";
export { ForwardRef as ReactComponent };